import { useContext, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import AuthContext from "../../context/AuthContext";
import useSnackBar from "../../hooks/UseSnackBar";
import SnackbarAlert from "../../components/SnackBar";
import { FormattedMessage } from "react-intl";
import SimpleEntityTab from "./tabs/SimpleEntityTab";
import UniversitiesTab from "./tabs/UniversitiesTab";
import MajorsTab from "./tabs/MajorsTab";
import { ACADEMIC_DEGREES_CONFIG, TEACHER_SPECIALIZATIONS_CONFIG } from "./academicConfig";
import AdminPageHero from "../../components/AdminPageHero";
import PageContent from "../../components/PageContent";
import ScrollReveal from "../../components/motion/ScrollReveal";

function AcademicStructure() {
    const { wait } = useContext(AuthContext);
    const { openSnackBar, type, message, setSnackBar, setOpenSnackBar } = useSnackBar();
    const [tab, setTab] = useState(0);

    const setSnack = (severity, msg) => setSnackBar(severity, msg);

    return (
        <>
            <PageContent wait={wait}>
                <AdminPageHero />
                <ScrollReveal>
                    <Tabs
                        value={tab}
                        onChange={(_, v) => setTab(v)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
                    >
                        <Tab label={<FormattedMessage id="universities" />} />
                        <Tab label={<FormattedMessage id="majors" />} />
                        <Tab label={<FormattedMessage id="academic_degrees" />} />
                        <Tab label={<FormattedMessage id="teacher_specializations" />} />
                    </Tabs>
                </ScrollReveal>
                <ScrollReveal delay={60}>
                    {tab === 0 && <UniversitiesTab setSnackBar={setSnack} />}
                    {tab === 1 && <MajorsTab setSnackBar={setSnack} />}
                    {tab === 2 && <SimpleEntityTab config={ACADEMIC_DEGREES_CONFIG} setSnackBar={setSnack} />}
                    {tab === 3 && <SimpleEntityTab config={TEACHER_SPECIALIZATIONS_CONFIG} setSnackBar={setSnack} />}
                </ScrollReveal>
            </PageContent>
            <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
        </>
    );
}

export default AcademicStructure;
